import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import * as environment from '../../config/settings/environment'
import getFeaturesFlags from './ProtectByFeatures.utils'

/**
 * The ProtectByFeatures' component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props
  const features = getFeaturesFlags(environment)
  const result = rule(features)
  if (!result && redirectTo) {
    return <Navigate replace to={redirectTo} />
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: () => true
}
ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
